var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pieChart",staticClass:"pie-chart h100 pdb10"},_vm._l((_vm.num),function(item){return _c('div',{key:item,ref:"myChart",refInFor:true,staticClass:"myChart"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }